import { Component,Input } from '@angular/core';
import { PlayerService } from '../services/player.service';

@Component({
  selector: 'next-track',
  templateUrl: './next-track.component.html',
  styleUrls: ['./next-track.component.css']
})
export class NextTrackComponent {
  @Input() belongsToRadio: any;
  public isPlayed:boolean = false;

  constructor(private playerService: PlayerService) { }

  nextTrack() {
    this.isPlayed = true;
    this.playerService.nextTrack(true);
    setTimeout(() => {
      this.isPlayed=false;
    }, 1000);
  }

}



// WEBPACK FOOTER //
// ./src/app/player/next-track/next-track.component.ts